import React from "react";
import { motion } from "framer-motion";

const ItemExperience = ({ data, is, delay = 0 }) => {
    return (
        <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.5, delay: delay * 0.1 }}
            className={`relative pl-8 sm:pl-10 ${!is ? 'pb-10' : ''}`}
        >
            {/* Timeline line and dot */}
            <div className="absolute left-0 top-0 bottom-0 flex flex-col items-center">
                <div className="w-4 h-4 rounded-full bg-dark-800 border-2 border-accent-cyan z-10 shadow-[0_0_10px_rgba(34,211,238,0.5)]"></div>
                {!is && <div className="w-px h-full bg-white/10 my-2"></div>}
            </div>

            <div className="glass-card p-6 rounded-2xl hover:border-accent-cyan/30 transition-colors duration-300">
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-4 gap-2">
                    <div>
                        <h3 className="text-xl font-bold text-white mb-1">{data.cargo}</h3>
                        <h4 className="text-accent-cyan font-medium text-sm uppercase tracking-wider">{data.empresa}</h4>
                    </div>
                    <div className="inline-block px-3 py-1 rounded-full bg-white/5 border border-white/10 text-xs text-slate-300 whitespace-nowrap">
                        {data.inicio} - {data.fin}
                    </div>
                </div>
                
                <span className="inline-block text-slate-400 text-sm mb-4 bg-dark-900 border border-white/5 px-2 py-1 rounded-md">
                    {data.ubicacion} • {data.tipo}
                </span>
                
                <p className="text-slate-400 text-sm leading-relaxed mb-0 font-light">
                    {data.descripcion}
                </p>
            </div>
        </motion.div>
    );
};

export default ItemExperience;
